<template>
  <smd-one-col-layout content-styles="full-width">
    <div class="pending">
      <pulsate-icon pulsateColor="blue"
                    size="large">
        <img :src="$options.NSLogo" alt="" class="pending__logo">
      </pulsate-icon>
      <div class="pending__text-container">
        <p class="Title1">Waiting for Approval</p>
        <p class="Body1">
          We've notified your doctor! We'll let you know once your doctor has approved the consultation request.
        </p>
      </div>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import PulsateIcon from '@/views/ondemand/components/pulsate-icon.vue';
  import NSLogo from '@/assets/icons/now-serving-heart.svg';

  export default {
    name: 'pending',
    components: {
      PulsateIcon,
    },
    NSLogo,
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .pending {
    @extend %layout--flex-center-xy;
    height: 100%;
    gap: 16px;

    &__logo {
      width: 60px;
      height: 60px;
    }

    &__text-container {
      @extend %layout--flex-col;
      gap: 10px;
      text-align: center;
      max-width: 380px;

      @include responsive(mobile) {
        max-width: 280px;
      }
    }
  }
</style>
